export default __webpack_public_path__ + "static/media/paradontologie.72f580fe.png";